import React, {Component} from "react";
import './style.scss';
import ModalWrapper, { withOnClose } from "../ModalWrapper";
import ResendCodeButton2FA from "src/components/ResendCodeButton2FA/ResendCodeButton2FA";
import Translator from "src/requests/apa/Translator";
import Utils, { secondsToMiliseconds } from "src/utils/Utils";
import { send2FA } from "src/requests/loader";
import timerManager, { MINUTES_TO_HELP } from "src/2FA/TimerManager";
import { showConfirmPurchase60Seconds } from "src/payments/utils/Utils";
import { removeDynamicFocus } from "src/components/Focus/utils";
import Device from "src/devices/device";
import DeviceStorage from "src/components/DeviceStorage/DeviceStorage";
import { CODIGOEXPIRADO, MODALCODIGOEXPIRADO, SOLICITARCODIGOEXPIRADO } from '../../../AAFPlayer/constants';
import {GA4} from '../../../utils/trackers/GA4';
import logger from 'src/utils/logger/logger';

interface IDataBuyConfirm {
  send2fa: string;
  mail?: string;
  phone?: string;
}

interface IProps{
  dataBuyconfirm: IDataBuyConfirm;
  dataToShowTicket: object;
  titleVOD: string;
  producttype: string;
  transactionId: string;
  dataMetrics2FA: any
  history: any
  callbackWhenBack?: () => void;
}
interface IState {
  maxNumResends: number;
  countResends: number;
}

class ExpiredCode2FA extends Component<IProps, IState> {
  static defaultProps: { handleClose: () => void; };
  timeToEnabled: number;
  keys: any;
  device: string;
  getParamsMetrics2FA: any;

  constructor(props: IProps){
    super(props);
    this.timeToEnabled = secondsToMiliseconds(Utils.getRegionaliazedMetadata('2fa_config').seconds_to_resend || 0);
    this.keys = Device.getDevice().getKeys();

    this.state = {
      maxNumResends: parseInt(DeviceStorage.getItem('max_num_resend_2FA')) || 0,
      countResends: parseInt(DeviceStorage.getItem('count_2FA')) || 0,
    }
    this.device =  Device.getDevice().getPlatform();
    this.handleClick = this.handleClick.bind(this);
      this.getParamsMetrics2FA = Utils.getParamsMetricsModals2FA(this.props.dataMetrics2FA, CODIGOEXPIRADO  , this.props.history.location.pathname, MODALCODIGOEXPIRADO, this.props.dataBuyconfirm && this.props.dataBuyconfirm.phone, this.props.dataBuyconfirm && this.props.dataBuyconfirm.mail);
  }

  sendGA4Metric(){
    const gA4 = new GA4();
    gA4.sendMetrics2FA(this.getParamsMetrics2FA, SOLICITARCODIGOEXPIRADO);
  }

  handleClick = async () => {
    try{
      this.sendGA4Metric();
      await send2FA({transactionId: this.props.transactionId, send2faURL:this.props.dataBuyconfirm.send2fa});
      timerManager.deleteTransaction(this.props.transactionId)
      showConfirmPurchase60Seconds(this.props.dataBuyconfirm, this.props.dataToShowTicket);

    }catch (error){
      logger.error(error)
    }
  }

  async componentDidMount(): Promise<void> {
    removeDynamicFocus();
    timerManager.createTimer(this.props.transactionId, MINUTES_TO_HELP)
  }

  getContactUserText = () => {
    const { mail, phone } = this.props.dataBuyconfirm;
    if(phone && mail) {
      return(
        <p className={`contact-user-text ${this.device}`}>
            {Translator.get('Alerta_2FATelmex_CodigoExpirado_TextoMensaje1_Parte1')}
            <span> {phone} </span>
            {Translator.get('Alerta_2FATelmex_CodigoExpirado_TextoMensaje1_Parte3')}
            <span> {mail}</span>
        </p>
      )
    }

    if(phone){
      return(
          <p className={`contact-user-text ${this.device}`}>
            {Translator.get('Alerta_2FATelmex_CodigoExpirado_TextoMensaje1_Parte1')}
            <span> {phone}</span>
        </p>
      )
    }

    if(mail){
      return(
          <p className={`contact-user-text ${this.device}`}>
            {Translator.get('Alerta_2FATelmex_CodigoExpirado_TextoMensaje1_Correo_Parte1')}
            <span> {mail}</span>
        </p>
      )
    }
  }

  render() {
    const {maxNumResends, countResends} = this.state;
    Utils.setInitialFocusChangeTime('#resendMessage', 0)

    const titleVODorADDON = this.props.titleVOD ? this.props.titleVOD : Translator.get(`Alerta_2FATelmex_CodigoExpirado_${this.props.producttype}`);

    return (
      <ModalWrapper callbackWhenBack={this.props.callbackWhenBack}>
        <div className='FullHD ExpiredCode'>
          <h1>{Translator.get('Alerta_2FATelmex_CodigoExpirado_TextoTitulo')}</h1>
          <h2>{titleVODorADDON}</h2>
          {this.getContactUserText()}
          <p className={`resendcode-text ${this.device}`}>
            {Translator.get('Alerta_2FATelmex_CodigoExpirado_TextoMensaje2_Parte1')}
            <span> {Translator.get('Alerta_2FATelmex_CodigoExpirado_TextoMensaje2_Parte2')} </span>
             {Translator.get('Alerta_2FATelmex_CodigoExpirado_TextoMensaje2_Parte3')}
          </p>

        <div>
          <ResendCodeButton2FA
            label={<p>{Translator.get('Alerta_2FATelmex_TextoBotonPrimario_SolicitarCodigoNuevo')}</p>}
            classname={`resendCode-btn ${this.device}`}
            maxNumResends={maxNumResends}
            countResends={countResends}
            timeToEnabled={this.timeToEnabled}
            onClick={this.handleClick}
            startDisabled={false}
          />
        </div>

          <div>
            <h2 className="help-text">{Translator.get('Alerta_2FATelmex_TextoTituloAyuda')}</h2>
            <p className="contact-text">
              {Translator.get('Alerta_2FATelmex_CodigoExpirado_TextoAyuda1')} {Translator.get('Alerta_2FATelmex_CodigoExpirado_TextoAyuda2')}
            </p>
          </div>
        </div>
      </ModalWrapper>
    )
  }
}

ExpiredCode2FA.defaultProps = {
	handleClose: () => {},
};

export default withOnClose(ExpiredCode2FA);



// WEBPACK FOOTER //
// ./src/components/Modal/ExpiredCode2FA/ExpiredCode2FA.tsx